import React from 'react';
import MobileRegister from '../../component/MobileRegister';
import PayDayPanel from '../../component/PayDayPanel';

/*
  Layout contract
  ───────────────
  Desktop (≥ 769px) : two equal 50 / 50 columns, full viewport height
  Mobile  (≤ 768px) : single column — login card on top, promo panel below
  Both panels use flex:1 1 50% so they always share the space equally.
  A CSS class + <style> tag keeps the breakpoint logic out of JS entirely.
*/

export default function Login() {
  return (
    <>
      <style>{`
        .login-page {
          min-height: 100vh;
          background: rgb(231, 240, 253);
          display: flex;
          flex-direction: row;
          align-items: stretch;
        }

        /* Right panel */
        .login-right {
          flex: 1 1 50%;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2.5rem 2rem;
          border-left: 0.5px solid rgba(37, 99, 235, 0.1);
          min-width: 0;
          overflow: hidden;
        }

        /* =========================
          Tablet + Mobile
        ========================== */
        @media (max-width: 1024px) {
          .login-page {
            flex-direction: column;
          }

          .login-right {
            order: -1; /* show login on top */

            width: 100%;
            flex: none;

            border-left: none;
            border-top: 0.5px solid rgba(37, 99, 235, 0.1);

            padding: 2rem 1.5rem;
          }
        }

        /* =========================
          Large Phones
        ========================== */
        @media (max-width: 768px) {
          .login-right {
            padding: 1.5rem 1.25rem;
          }
        }

        /* =========================
          Small Phones
        ========================== */
        @media (max-width: 480px) {
          .login-page {
            min-height: auto;
          }

          .login-right {
            padding: 1.25rem 1rem;
          }
        }
      `}</style>

      <div className="login-page">
        {/* Left — PayDay promo panel */}
        <PayDayPanel />

        {/* Right — login form */}
        <div className="login-right">
          <MobileRegister />
        </div>
      </div>
    </>
  );
}
